import IconClusterLayer from 'common/utils/DeckGl/Layers/IconClusterLayer';
import { MapMarkerLayer } from '../../types';

import commonLayerSettings from '../utils/commonLayerSettings';

const clusterLayerCreator = (props: MapMarkerLayer) => new IconClusterLayer({
  ...commonLayerSettings,
  ...props
});

export default clusterLayerCreator;
